import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDeleteDocumentIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M12.1179 15.5H5.11792C4.8527 15.5 4.59835 15.3946 4.41081 15.2071C4.22328 15.0196 4.11792 14.7652 4.11792 14.5V5.5H13.1179V14.5C13.1179 14.7652 13.0126 15.0196 12.825 15.2071C12.6375 15.3946 12.3831 15.5 12.1179 15.5Z",
			stroke: "#001489",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.11792 12.5V8.5",
			stroke: "#001489",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.1179 12.5V8.5",
			stroke: "#001489",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.61792 4.14133L14.3339 1.43866",
			stroke: "#001489",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.02741 0.521976L6.09407 1.14531C5.96532 1.17248 5.8432 1.22479 5.7347 1.29925C5.6262 1.3737 5.53347 1.46884 5.46181 1.57921C5.39016 1.68957 5.34099 1.81299 5.31712 1.9424C5.29326 2.0718 5.29516 2.20464 5.32274 2.33331L5.53341 3.30998L10.4241 2.26998L10.2134 1.29198C10.1582 1.03261 10.0023 0.805789 9.77985 0.661392C9.55744 0.516994 9.28678 0.466846 9.02741 0.521976V0.521976Z",
			stroke: "#001489",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgDeleteDocumentIcon);
export default ForwardRef;
